import upsellItem from './upsellItem';

export default {
  template: '#upsell_additions',
  components: {
    upsellItem,
  },
  data: function() {
    return {
      campaignUpsells: [],
      viewUpsells: [],
      currentScrollLimit: 0,
      currentCampaigns: [],
      disableUpsellButtons: false,
      disableSelfUpsellButton: false,
      disableModalUpsellButton: false,
      searchCampaignName: '',
      isSearching: false,
      disableUpsellConfiguration: false
    };
  },
  ready() {
    $('.upsell-campaigns-list').mCustomScrollbar({
      setHeight: '600px',
      theme: 'dark-thick'
    });
  },
  created: function() {
    var that = this;

    var removeUpsell = function(id) {
      var idx = '';
      if (id == 'SELF') {
        idx = _.findIndex(that.campaignUpsells, function(upsell) {
          return upsell.type == 'SELF';
        });

      } else {
        idx = _.findIndex(that.campaignUpsells, function(upsell) {
          return (upsell.type == 'CAMPAIGN' && upsell.campaign.id == id);
        });
      }

      that.campaignUpsells.splice(idx, 1);

      if (that.campaignUpsells.length < 2) {
        that.disableUpsellButtons = that.disableUpsellConfiguration;
      }

      //Enable the Self Upsell button if it is removed from the upsells.
      var selfUpsellExists = _.find(that.campaignUpsells, function(upsell) {
        return upsell.type == 'SELF';
      });
      if (!selfUpsellExists || selfUpsellExists == undefined || selfUpsellExists == null) {
        that.disableSelfUpsellButton = that.disableUpsellConfiguration;
      }

      var campaignUpsells = that.$root.campaignData.campaign_upsells,
        campaignUpsellIdx = -1;

      if (id == 'SELF') {
        campaignUpsellIdx = _.findIndex(campaignUpsells, function(upsell) {
          return upsell.type == 'SELF';
        });
      } else {
        var campaignUpsellId = id;
        campaignUpsellIdx = _.findIndex(campaignUpsells, function(upsell) {
          return upsell.campaignId == campaignUpsellId;
        });
      }
      if (campaignUpsellIdx != -1)
        that.$root.campaignData.campaign_upsells.splice(campaignUpsellIdx, 1);
    }

    this.$on('disable-upsell-configuration', function(isDisabled) {
      this.$set('disableSelfUpsellButton', isDisabled);
      this.$set('disableUpsellButtons', isDisabled);
      this.$set('disableUpsellConfiguration', isDisabled)
    });

    this.$on('upsell-removed', function(id) {
      removeUpsell(id);
    });

    this.$on('on-product-select', function(selectedProduct) {

      // clear self upsells if selected product doesn't allow
      if (!selectedProduct.product.allow_as_upsell) {

        var selfUpsell = _.find(that.campaignUpsells, function(upsell) {
          return upsell.type === 'SELF';
        });

        if (typeof selfUpsell === 'object') {
          removeUpsell('SELF');
        }

      }

      that.disableSelfUpsellButton = !selectedProduct.product.allow_as_upsell;

    });
  },
  filters: {
    userTimezone: function(val) {
      return this.$root.formatDate(val);
    }
  },
  methods: {
    getUpsells: function() {
      this.$set('viewUpsells', []);
      helpers.showProcessing(false);
      this.isSearching = true;
      this.loadUpsells();
    },
    loadUpsells: function() {
      var obj = {
          start_limit: this.currentScrollLimit,
          existing_campaigns: this.currentCampaigns,
          campaign_name: this.searchCampaignName
        },
        that = this;
      Vue.http.get(this.$root.getRequestService().ajaxBase + 'upsells', obj).then(function(response) {
        var res = response.data;
        helpers.hideProcessing();
        that.isSearching = false;
        if (res.status == "SUCCESS") {
          if (that.viewUpsells.length > 0) {
            var existingUpsells = that.viewUpsells;
            that.$set('viewUpsells', existingUpsells.concat(res.data));
          } else {
            that.$set('viewUpsells', res.data);
          }
          $('#add_upsell_modal').modal({
            show: true,
            keyboard: false,
            backdrop: 'static'
          });

          that.disableModalUpsellButton = false;
        }
      }, function() {
        helpers.hideProcessing();
        helpers.alert('Error Loading Upsells');
      });
    },
    addUpsell: function(upsell) {
      var campaignUpsells = this.campaignUpsells,
        that = this,
        upsell_id = upsell.id;

      var upsellExists = _.find(this.campaignUpsells, function(upsellObj) {
        if (upsell.campaign)
          return upsellObj.campaign.id == upsell_id;
      });

      if (upsellExists) {
        helpers.alert('This campaign has already been added as an Upsell to this campaign');
      } else {
        this.disableModalUpsellButton = true;
        helpers.showProcessing(false);
        Vue.http.get(this.$root.getRequestService().ajaxBase + 'campaign-products/' + upsell.id).then(function(response) {
          var res = response.data;
          helpers.hideProcessing();
          if (res.status == 'SUCCESS') {
            var campaignProducts = res.data;
            campaignUpsells.push({
              campaign: upsell,
              products: campaignProducts,
              type: 'CAMPAIGN'
            });
            that.$set('campaignUpsells', campaignUpsells);
            $('#add_upsell_modal').modal('hide');
          } else {
            helpers.alert(res.message + ' for this campaign');
          }

          that.disableModalUpsellButton = false;

          if (that.campaignUpsells.length == 2) {
            that.disableSelfUpsellButton = true;
            that.disableUpsellButtons = true;
          }
        });
      }
    },
    addSelfUpsell: function() {
      var campaignUpsells = this.campaignUpsells,
        checkSelfUpsells = _.find(campaignUpsells, function(upsell) {
          return upsell.type == 'SELF';
        });

      if (checkSelfUpsells == undefined) {
        campaignUpsells.push({ type: 'SELF' });
        this.$set('campaignUpsells', campaignUpsells);

        this.disableSelfUpsellButton = true;
        if (this.campaignUpsells.length == 2)
          this.disableUpsellButtons = true;
      }
    },
    isSublimationProduct: function() {
      return this.$root.isSublimationProduct();
    },
    isAPIOrder: function() {
      return this.$root.isAPIOrder();
    }
  },
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/launch_tab/upsellAdditions.js